import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertTriangle, Brain, Briefcase, BatteryWarning } from 'lucide-react';
export function ProblemSection() {
  return <div className="bg-navy text-cream border-t border-gold/10" data-id="element-158">
      <SectionWrapper data-id="element-159">
        <div className="max-w-4xl mx-auto" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-12 text-white" data-id="element-161">
            La mayoría de los consejos sobre el sueño del bebé están escritos
            para personas que pueden{' '}
            <span className="text-gold italic" data-id="element-162">dormir una siesta</span> durante
            el día.
          </h2>

          <p className="text-xl text-center text-cream/90 mb-16 font-sans" data-id="element-163">
            Tú no tienes ese lujo. Tú tienes reportes que entregar, equipos que
            liderar y una carrera que proteger.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12" data-id="element-164">
            <div className="bg-navy-light p-8 rounded-sm border border-gold/10 flex flex-col items-center text-center" data-id="element-165">
              <Brain className="text-gold mb-6" size={40} data-id="element-166" />
              <h3 className="text-xl font-serif text-white mb-4" data-id="element-167">
                Cerebro Inflamado
              </h3>
              <p className="text-cream/70 font-sans" data-id="element-168">
                Cuando tu hijo no duerme, tu cerebro se inflama. Tu capacidad de
                tomar decisiones cae un 40%.
              </p>
            </div>

            <div className="bg-navy-light p-8 rounded-sm border border-gold/10 flex flex-col items-center text-center" data-id="element-169">
              <BatteryWarning className="text-gold mb-6" size={40} data-id="element-170" />
              <h3 className="text-xl font-serif text-white mb-4" data-id="element-171">
                Paciencia Agotada
              </h3>
              <p className="text-cream/70 font-sans" data-id="element-172">
                Tu paciencia se agota y empiezas a sentir que estás fallando
                tanto en el trabajo como madre.
              </p>
            </div>

            <div className="bg-navy-light p-8 rounded-sm border border-gold/10 flex flex-col items-center text-center" data-id="element-173">
              <AlertTriangle className="text-gold mb-6" size={40} data-id="element-174" />
              <h3 className="text-xl font-serif text-white mb-4" data-id="element-175">
                Emergencia Profesional
              </h3>
              <p className="text-cream/70 font-sans" data-id="element-176">
                El agotamiento crónico no es una medalla de honor, es una
                emergencia para tu carrera.
              </p>
            </div>
          </div>
        </div>
      </SectionWrapper>
    </div>;
}